import i18n from '@/assets/i18n/translate-message';

export const FILTER_BY_START_TIME = 'StartTime';
export const FILTER_BY_CLOSE_TIME = 'CloseTime';

export const FILTER_MODE_ADVANCED = 'advanced';
export const FILTER_MODE_BASIC = 'basic';

export const IS_CRON_ALL = '';
export const IS_CRON_TRUE = 'true';
export const IS_CRON_FALSE = 'false';
export const IS_CRON_LIST = [{
    value: IS_CRON_ALL,
    label: 'All',
  },
  {
    value: IS_CRON_TRUE,
    label: 'Is a cron',
  },
  {
    value: IS_CRON_FALSE,
    label: 'Is not a cron',
  },
];
export const IS_CRON_LIST_OPTION_DEFAULT = IS_CRON_LIST[0];

export const STATE_ALL = 'all';
export const STATE_CLOSED = 'closed';
export const STATE_OPEN = 'open';

export const STATUS_ALL = 'ALL';
export const STATUS_CANCELED = 'CANCELED';
export const STATUS_CLOSED = 'CLOSED';
export const STATUS_COMPLETED = 'COMPLETED';
export const STATUS_CONTINUED_AS_NEW = 'CONTINUED_AS_NEW';
export const STATUS_FAILED = 'FAILED';
export const STATUS_OPEN = 'OPEN';
export const STATUS_TERMINATED = 'TERMINATED';
export const STATUS_TIMED_OUT = 'TIMED_OUT';

export const STATUS_LIST = [{
    value: STATUS_ALL,
    label: i18n.t('dj-全部'),
    staus: 'all',
  },
  {
    value: STATUS_OPEN,
    status: '6',
    label: i18n.t('dj-运行中'),
  },
  {
    value: STATUS_FAILED,
    status: '1',
    label: i18n.t('dj-失败'),
  },
  {
    value: STATUS_CANCELED,
    status: '2',
    label: i18n.t('dj-取消'),
  },
  {
    value: STATUS_TERMINATED,
    status: '3',
    label: i18n.t('dj-中止'),
  },
  {
    value: STATUS_CONTINUED_AS_NEW,
    status: '4',
    label: i18n.t('dj-重新开始'),
  },
  {
    value: STATUS_TIMED_OUT,
    status: '5',
    label: i18n.t('dj-超时'),
  },
];

export function GETSTATUS_LIST(i18) {
  return [{
    value: STATUS_ALL,
    label: i18.t('dj-全部'),
    staus: 'all',
  },
  {
    value: STATUS_OPEN,
    status: '6',
    label: i18.t('dj-运行中'),
  },
  {
    value: STATUS_FAILED,
    status: '1',
    label: i18.t('dj-失败'),
  },
  {
    value: STATUS_CANCELED,
    status: '2',
    label: i18.t('dj-取消'),
  },
  {
    value: STATUS_TERMINATED,
    status: '3',
    label: i18.t('dj-中止'),
  },
  {
    value: STATUS_CONTINUED_AS_NEW,
    status: '4',
    label: i18.t('dj-重新开始'),
  },
  {
    value: STATUS_TIMED_OUT,
    status: '5',
    label: i18.t('dj-超时'),
  },
];
}


export function GETSTATUSLABLE(val, i18) {
  switch (val) {
    case 1:
      return i18.t('dj-失败');
    case 0:
      return i18.t('dj-完成');
    case 6:
      return i18.t('dj-运行中');
    case 3:
      return i18.t('dj-中止');
    case 5:
      return i18.t('dj-超时');
    case 2:
      return i18.t('dj-取消');
    case 4:
      return i18.t('dj-重新开始');
    default:
      return i18.t('dj-失败');
  }
}

export const STATUS_LIST_OPTION_DEFAULT = STATUS_LIST[0];
